import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom/client';
import moment from 'moment';
import Barcode from 'screens/components/basic/Barcode';
import Header from './Header';
import Content from './Content';
import PrintLabelDialog from 'screens/components/basic/PrintLabelDialog';
import {
    getProductById, getProductOrders, getCampaignList, getPurchaseOrderList, resetProductList, getProducts, deleteProduct
} from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
import { getInventoryLevel, getInventorySnapShotProductView, clearInventoryChart } from '../../../../../../src/actions/ReportsAction';
import WithRouter from '../../../../../custom/withRouter';

class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                orders: {
                    activePage: 1,
                    itemsPerPage: 10
                },
                po: {
                    activePage: 1,
                    itemsPerPage: 10
                },
                campaign: {
                    activePage: 1,
                    itemsPerPage: 10
                }
            },
            tabs: {
                value: "a"
            },
            printLabelDialog: false,
            barcode: "",
            quantity: "",
            productName: "",
            store: "",
            price: ""
        };

        this.ws = null;
        this.inventory = [];
        this.fixInventory = [];
        this.chartLength = 0;
        this.loadOrders = this.loadOrders.bind(this);
        this.loadPO = this.loadPO.bind(this);
        this.loadCampaign = this.loadCampaign.bind(this);
        this.changePage = this.changePage.bind(this);
        this.printLabel = this.printLabel.bind(this);
        this.printByService = this.printByService.bind(this);
        this.clearPrintQuantity = this.clearPrintQuantity.bind(this);
        this.handleTabs = this.handleTabs.bind(this);
        this.handleInventoryFilter = this.handleInventoryFilter.bind(this);

    }

    componentWillMount() {
        this.inventory = [];
        this.fixInventory = [];
        try {
            this.initWebSocket();
        } catch (err) {
            console.log(`WebSocket Error: ${err}`);
            this.initWebSocket();
        }
    }

    componentDidMount() {
        this.props.getProductById(this.props.params.id, this.props.branchId);
        this.handleInventoryFilter();
        this.props.formInput(false, "productdelete" + "SaveSuccess");
    }

    componentWillReceiveProps(newProps) {

        if ((newProps.inventory && newProps.inventory != this.props.inventory && newProps.inventorySnapShot.length > 0) ||
            (newProps.inventorySnapShot && newProps.inventorySnapShot != this.props.inventorySnapShot && newProps.inventory.length > 0)) {
            const inventorySnapShot = newProps.inventorySnapShot.map(item => ({ ...item }))
            let initSumQty = inventorySnapShot[0] ? inventorySnapShot[0].storageQuantity + inventorySnapShot[0].storeQuantity : 0;
            this.inventory = newProps.inventory.map(item => ({ ...item }));
            this.fixInventory = [];
            let startDate = moment().format('YYYY-MM-DD');
            let inventoryIndex = 0;
            this.inventory.filter(x => x.changedDate = moment(x.changedDate).format('YYYY-MM-DD'));
            for (let i = 0; i < this.chartLength; i++) {
                let model = {
                    changedDate: moment(startDate).format('MMMM D'),
                    quantity: initSumQty >= 0 ? initSumQty : 0
                }
                this.fixInventory.unshift(model);
                if (this.inventory[inventoryIndex] != undefined && this.inventory[inventoryIndex].changedDate == startDate) {
                    initSumQty = initSumQty - this.inventory[inventoryIndex].sumChangedQty;
                    inventoryIndex++;
                }

                startDate = moment(startDate).subtract(1, 'day').format('YYYY-MM-DD');
            }
            this.fixInventory.filter(x => x.changedDate = moment(x.changedDate).format('MMMM D'));

        }
        if (newProps.saveSuccess != this.props.saveSuccess && newProps.saveSuccess) {
            this.callListView();
        }
    }

    componentWillUnmount() {
        this.props.resetProductList();
        this.props.clearInventoryChart();
        this.inventory = [];
        this.fixInventory = [];
        this.ws.close(1000);
    }

    handleTabs = (event, value) => {
        this.setState(prevState => ({
            tabs: {
                ...prevState.tabs,
                value: value
            }
        }));
    }

    handleDeleteProduct = (productId) => {
        this.props.deleteProduct({ productId: productId });
        this.getProducts();
    }

    callListView = () => {
        this.props.navigate("/product");
    }

    getProducts = () => {

        const model = {
            branchId: this.props.branchId,
            page: 1,
            itemsPerPage: 25,
            searchText: "",
            descriptionStatus: 0,
            categoryId: null,
            sku: "",
            priceMatrixId: null,
            status: 'None',
            imageStatus: 0,
            typeId: null,
            orderBy: "DESC",
            sortBy: ""
        };
        this.props.getProducts(model);
    }


    //MOVE THAT TO CLASS
    //TODO
    initWebSocket() {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                }
            };

            this.ws.onerror = () => {
            };

            this.ws.onclose = (event) => {
                if (event.code !== 99999) {
                    console.log("Websocket is Locked!");
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(1000);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(`ERROR ON INIT FUNCTION CATCH: ${err}`);
        }
    }


    handleInventoryFilter = (type = 'month') => {
        let startDate = moment();
        switch (type) {
            case 'week':
                startDate = startDate.subtract(1, 'week').format('YYYY-MM-DD');
                this.chartLength = 7;
                break;
            case 'month':
                startDate = startDate.subtract(1, 'month').format('YYYY-MM-DD');
                this.chartLength = 30;
                break;
            case 'year':
                startDate = startDate.subtract(1, 'year').format('YYYY-MM-DD');
                this.chartLength = 365;
                break;
            default:
                break;
        }
        let modelForSnapShot = {
            branch: this.props.branchId,
            selectedDate: moment().format('YYYY-MM-DD'),
            productId: this.props.params.id,
            pageNumber: 1,
            pageSize: 99,
            category: 0,
            iscannabis: 2,
            weight: 0,
            species: 0
        }
        this.props.getInventorySnapShotProductView(modelForSnapShot);
        let model = {
            branch: this.props.branchId || 1,
            startDate: startDate,
            endDate: moment().format('YYYY-MM-DD'),
            pageNumber: 1,
            pageSize: 9999,
            category: 0,
            productId: this.props.params.id || 1
        }
        this.props.getInventoryLevel(model);
    }

    loadOrders() {
        //change for hasOwnProperty
        if (this.props.orderList.list.length === 0) {
            this.getOrders();
        }

    }

    getOrders() {
        const model = {
            productId: this.props.params.id,
            branchId: this.props.branchId,
            page: this.state.pagination.orders.activePage,
            itemsPerPage: this.state.pagination.orders.itemsPerPage,
            orderBy: 'DESC',
            sortBy: 'Id',
            status: "None",
            PatientFirstName: "",
            EmployeeFirstName: ""

        };

        this.props.getProductOrders(model);
    }

    loadPO() {
        //change for hasOwnProperty
        if (this.props.poList.list.length === 0) {
            this.getPO();
        }
    }

    getPO() {
        const model = {
            productId: this.props.params.id,
            branchId: this.props.branchId,
            page: this.state.pagination.po.activePage,
            itemsPerPage: this.state.pagination.po.itemsPerPage,
            orderBy: 'DESC',
            sortBy: 'Id'
        };
        this.props.getPurchaseOrderList(model);
    }

    loadCampaign() {
        //change for hasOwnProperty
        if (this.props.campaignList.list.length === 0) {
            this.getCampaign();
        }
    }

    getCampaign() {
        const model = {
            productId: this.props.params.id,
            branchId: this.props.branchId,
            page: this.state.pagination.campaign.activePage,
            itemsPerPage: this.state.pagination.campaign.itemsPerPage
        }

        this.props.getCampaignList(model);
    }

    changePage = (page, compName) => {
        if (compName === "orders") {
            this.setState(prevState => {
                return {
                    ...prevState,
                    pagination: {
                        ...prevState.pagination,
                        orders: {
                            ...prevState.pagination.orders,
                            activePage: page
                        }
                    }
                }
            }, () => this.getOrders());
        }

        if (compName === "po") {
            this.setState(prevState => {
                return {
                    ...prevState,
                    pagination: {
                        ...prevState.pagination,
                        po: {
                            ...prevState.pagination.po,
                            activePage: page
                        }

                    }
                }
            }, () => this.getPO());
        }

        if (compName === "campaign") {
            this.setState(prevState => {
                return {
                    ...prevState,
                    pagination: {
                        ...prevState.pagination,
                        campaign: {
                            ...prevState.pagination.campaign,
                            activePage: page
                        }
                    }
                }
            }, () => this.getCampaign());
        }
    }

    printByService() {
        const model = {
            command: "PRINT BARCODE",
            data: JSON.stringify([{
                CompanyName: this.state.store,
                ProductName: this.state.productName,
                Quantity: this.state.quantity,
                Barcode: this.state.barcode,
                NumberOfCopies: this.props.printQuantity ? this.props.printQuantity : 1,
                Price: this.state.price
            }])
        };

        this.ws.send(JSON.stringify(model));
        this.setState({ printLabelDialog: false });
    }

    printByJs() {
        if ((this.state.printLabelDialog && this.state.barcode !== '' && this.props.printQuantity > 0) || (this.state.barcode !== '' && this.state.quantity > 0)) {
            this.printByService();
        } else if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.setState({ printLabelDialog: true });
        } else {
            const toPrint = ReactDOM.createRoot(document.getElementById('to-print'));
            toPrint.render (<Barcode code={this.state.barcode} format={"CODE128B"} width={2} print={true} />);
        }
    }

    printLabel = (barcode, quantity = 0, price = null) => {
        this.setState(pState => {
            return {
                ...pState,
                barcode: barcode,
                quantity: quantity,
                productName: this.props.productInfo.name,
                store: this.props.store.name,
                price: price
            };
        }, this.printByJs);
    }

    saveToPDF = (barcode) => {
        this.setState(pState => {
            return {
                ...pState,
                barcode: barcode
            };
        }, this.saveToPDFDialog);
    }

    saveToPDFDialog = () => {
        const toPrint = ReactDOM.createRoot(document.getElementById('to-print'));
        toPrint.render (<Barcode code={this.state.barcode} format={"CODE128B"} width={2} print={true} />);
    }

    clearPrintQuantity(compName) {
        this.setState({ printLabelDialog: false });
        this.props.clearPrintQuantity(compName);
    }


    render() {
        return (
            this.props.productInfo ?
                <div>
                    <Header product={this.props.productInfo} printLabel={this.printLabel} isMedical={this.props.isMedical} handleDeleteProduct={this.handleDeleteProduct} saveToPDF={this.saveToPDF} allAccess={this.props.canAddEditProduct} />
                    <hr />
                    <Content
                        product={this.props.productInfo}
                        orders={this.props.orderList}
                        campaign={this.props.campaignList}
                        po={this.props.poList}
                        loadOrders={this.loadOrders}
                        loadCampaign={this.loadCampaign}
                        loadPO={this.loadPO}
                        changePage={this.changePage}
                        pagination={this.state.pagination}
                        printLabel={this.printLabel}
                        tabValue={this.state.tabs.value}
                        handleTabs={this.handleTabs}
                        isMedical={this.props.isMedical}
                        inventory={this.fixInventory}
                        inventoryFilter={this.handleInventoryFilter}
                    />
                    <PrintLabelDialog product={this.props.productInfo} open={this.state.printLabelDialog} printLabel={this.printLabel} clearPrintQuantity={this.clearPrintQuantity} />
                </div> : null
        )
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getProductById: (productId, branchId) => dispatch(getProductById(productId, branchId)),
        getProductOrders: (model) => dispatch(getProductOrders(model)),
        getCampaignList: (model) => dispatch(getCampaignList(model)),
        getPurchaseOrderList: (model) => dispatch(getPurchaseOrderList(model)),
        clearPrintQuantity: (compName) => dispatch(formInput("", compName)),
        resetProductList: () => dispatch(resetProductList()),
        getInventoryLevel: (model) => dispatch(getInventoryLevel(model)),
        getInventorySnapShotProductView: (model) => dispatch(getInventorySnapShotProductView(model)),
        clearInventoryChart: () => dispatch(clearInventoryChart()),
        deleteProduct: (model) => dispatch(deleteProduct(model)),
        getProducts: (model) => dispatch(getProducts(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
    };
}

function mapStateToProps(state) {
    return {
        canAddEditProduct: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanAddEditProduct")),
        branchId: state.common.branchId,
        productInfo: state.entity.productDetail,
        orderList: state.entity.productOrderList,
        campaignList: { list: state.entity.productCampaignList, total: state.entity.productCampaignTotal },
        poList: { list: state.entity.productPurchaseOrderList, total: state.entity.productPurchaseOrderTotal },
        store: state.common.store,
        printQuantity: state.form.labelQuantityProductBarcode,
        isMedical: state.common.applicationSettings.isMedical,
        inventory: state.reports.inventoryLevel || [],
        inventorySnapShot: state.reports.inventorySnapShot || [],
        saveSuccess: state.form["productdelete" + "SaveSuccess"],
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Body));
